import type { Vec2 } from '../../../../geo/types';
import { beamSolid, boxSolid, planPoint } from '../../solids';
import type { StadhuisBuild } from './stadhuisParts';

/** Luyken's vierschaar detail clarifies paired blind tracery panels below the upper windows.
 * Their shallow relief and dimensions are estimates; the 1538/1544 openings remain authoritative. */
function blindPanel(s: StadhuisBuild, center: number): void {
  const y = 7.75;
  const frame: readonly Vec2[] = [
    [-0.28, -0.27],
    [0.28, -0.27],
    [0.28, 0.27],
    [-0.28, 0.27],
  ];
  const tracery = Array.from({ length: 24 }, (_, i): Vec2 => {
    const angle = (i * Math.PI) / 12;
    const radius = 0.165 + 0.045 * Math.cos(4 * angle);
    return [radius * Math.cos(angle), radius * Math.sin(angle)];
  });
  for (const [ring, half] of [
    [frame, 0.035],
    [tracery, 0.022],
  ] as const)
    ring.forEach((a, i) => {
      const b = ring[(i + 1) % ring.length]!;
      beamSolid(
        s.builder,
        s.stone.wall,
        s.frame,
        planPoint(center + a[0], y + a[1], -0.12),
        planPoint(center + b[0], y + b[1], -0.12),
        half
      );
    });
}

/** Front-only relief stays above the arcade's walking clearance and inside its existing piers. */
export function buildVierschaarOrnaments(s: StadhuisBuild): void {
  const { arcade, vierschaar } = s.plan;
  for (const arch of arcade) for (const side of [-1, 1]) blindPanel(s, arch.center + side * 0.34);
  const piers = [
    0.3,
    ...arcade.slice(1).map((arch, i) => (arch.center + arcade[i]!.center) / 2),
    vierschaar.u1 - 0.3,
  ];
  for (const u of piers) {
    boxSolid(s.builder, s.stone.wall, s.frame, [u - 0.09, 7.3, 0.015], [u + 0.09, 12.65, 0.18]);
    for (const y of [7.35, 12.45])
      boxSolid(s.builder, s.stone.wall, s.frame, [u - 0.15, y, 0.015], [u + 0.15, y + 0.16, 0.23]);
  }
}
